require.config({
    paths: {
        'sharingTemplate': 'gameday-social-sharing/app/templates',
        'text': 'requirejs-text/text'
    }
});

define('gameday-social-sharing/app/gameday-social-sharing',['require','exports','module','social/social','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','text!sharingTemplate/sharing.mustache','text!sharingTemplate/shareBtn.mustache','text!sharingTemplate/shareBtn.mustache'],function(require, exports, module) {
    var Social = require("social/social");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var sharingTmpl = require('text!sharingTemplate/sharing.mustache');
    var shareBtnTmpl = require('text!sharingTemplate/shareBtn.mustache');
    var shareBtnTmpl = require('text!sharingTemplate/shareBtn.mustache');


    function Sharing(cfg) {
        this.target = cfg.target;
        this.shareBtn = null;
        this.socialDiv = this.target.find(".bam-social-container");
        this.aId = cfg.aId;
        this.url = cfg.url;
        this.title = cfg.title;
        this.open = null;
        this.close = null;
    }


    Sharing.prototype = {

        createShareBtn: function() {
            var templateBtn = hogan.compile(shareBtnTmpl);
            this.target.find(".bam-social-btn-container").html(templateBtn.render());
            return this;
        },

        init: function() {
            if (this.shareBtn === null) {
                this.shareBtn = this.target.find(".share-btn");
            }

            if (this.shareBtn.hasClass("off")) {
                this.removeSocial();
            } else {
                this.createSocial();
            }

        },

        removeSocial: function() {
            this.shareBtn.removeClass("off");
            $(this).trigger(this.events.GD_SHARE_OFF);
            this.open.removeClass("fadeOut").addClass("fadeIn");
            this.close.removeClass("fadeIn").addClass("fadeOut");

            
      

        },


        events: {
            "GD_SHARE_ON": "shareOn",
            "GD_SHARE_OFF": "shareOff"
        },


        createSocial: function() {
            var $target = this.target;
            this.open = $target.find(".openSocial");
            this.close = $target.find(".closeSocial");
            this.open.removeClass("fadeIn").addClass("fadeOut");
            this.close.removeClass("fadeOut").addClass("fadeIn");
            var template = hogan.compile(sharingTmpl);
            $target.find(".bam-social-container").html(template.render());



            var title = this.title;
            var url = this.url;
            var aId = this.aId;
            var twitterContainer = $target.find(".twitter a");
            var facebookContainer = $target.find(".facebook a");
            var googleContainer = $target.find(".google a");
            var subject = "title//n//n" + url;
            var emailLink = "mailto:?Subject=" + encodeURIComponent(title) + "&Body=" + encodeURIComponent(title) + "%0A" + encodeURIComponent(url) + "%0ASent%20from%20MLB.com%20Gameday";
            var shareBtn = $target.find(".share-btn");
            var socialDiv = $target.find(".bam-social-container");



            var socialLib = new Social.Lib({
                title: title,
                url: url,
                disableOnclick: true,
                showCounters: false,
                shorty: false,
                sequenceloading: false
            });

            socialLib.twitter(twitterContainer, {
                via: "mlb",
                related: "mlb",
                tracking: {
                    tcid: "tw_gameday_" + aId
                }
            }).facebook(facebookContainer, {
                type: "share",
                tracking: {
                    tcid: "fb_article_" + aId
                }
            }).google(googleContainer, {
                type: "share"
            });

            $target.find(".email a").on("click", function(e) {
                $(this).attr("href", emailLink);
            })


            socialDiv.show();
            shareBtn.addClass("off");
            $(this).trigger(this.events.GD_SHARE_ON);

        }

    }


    return Sharing;


});
